"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME = exports.TEXT = exports.STRING = exports.SIMPLE_SELECTION = exports.PERCENTAGE = exports.MULTIPLE_SELECTION = exports.INTEGER = exports.IMAGE = exports.FLOAT = exports.FILE = exports.DATE_TIME = exports.DATE = exports.CUSTOM = exports.COMPLEX = exports.AUTOCOMPLETE = void 0;
var STRING = exports.STRING = "STRING";
var PERCENTAGE = exports.PERCENTAGE = "PERCENTAGE";
var INTEGER = exports.INTEGER = "INTEGER";
var FLOAT = exports.FLOAT = "FLOAT";
var TEXT = exports.TEXT = "TEXT";
var DATE = exports.DATE = "DATE";
var DATE_TIME = exports.DATE_TIME = "DATE_TIME";
var TIME = exports.TIME = "TIME";
var SIMPLE_SELECTION = exports.SIMPLE_SELECTION = "SIMPLE_SELECTION";
var FILE = exports.FILE = "FILE";
var COMPLEX = exports.COMPLEX = "COMPLEX";
var AUTOCOMPLETE = exports.AUTOCOMPLETE = "AUTOCOMPLETE";
var CUSTOM = exports.CUSTOM = "CUSTOM";
var MULTIPLE_SELECTION = exports.MULTIPLE_SELECTION = "MULTIPLE_SELECTION";
var IMAGE = exports.IMAGE = "IMAGE";